import React from "react";
import { AIIntegration } from "./ai-integration";

export const AIIntegrationPage: React.FC = () => {
    return <AIIntegration />;
};
